export const GET_SMS_LOGS = 'GET_SMS_LOGS'
export const GET_SMS_LOG = 'GET_SMS_LOG'
